import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { NumberService } from '@phone-number/services/NumberService';
import { currency } from '@/plugins/vue-numeral/lib/filters';
import AddCustomNumber from '@phone-number/components/modal-add-custom-number';

class NumberModalService extends ModalService {
  constructor() {
    super(NumberService);
  }

  buy(id, item) {
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('phone-number.number.modal.buy.content', {
        number: `<strong>${item.number}</strong>`,
        connection_cost: `<strong>${currency(item.connection_cost)}</strong>`,
        subscription_fee: `<strong>${currency(item.subscription_fee)}</strong>`
      }),

      onOk: () => {
        NumberService.buy(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch(e => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          });
      }
    });
  }

  deactivate(id, item) {
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('phone-number.number.modal.deactivate.content', {
        number: `<strong>${item.number}</strong>`
      }),

      onOk: () => {
        NumberService.deactivate(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch(e => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          });
      }
    });
  }

  connect_pbx(id, item) {
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('phone-number.number.modal.connect_pbx.content', {
        number: `<strong>${item.number}</strong>`
      }),

      onOk: () => {
        NumberService.connectPBX(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch(e => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          });
      }
    });
  }

  add_custom() {
    return this.$confirm({
      loading: true,
      customFooter: true,
      title: i18n.t('phone-number.number.modal.add_custom.title'),
      render: h =>
        h(AddCustomNumber, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  required_documents(item) {
    return this.$confirm({
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('phone-number.number.modal.required_documents.content', {
        number: `<strong>${item.number}</strong>`
      }),
      onOk: () => this.$emit('success')
    });
  }
}

const instance = new NumberModalService();
export { instance as NumberModalService };
